import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Divider } from '@mui/material';
import UniversalChip from '@/components/UI/UniversalChip/UniversalChip';
import { chipTypes } from '@/helpers/constants';
import { LanguageValidations, PlantInfo, TranslatablePropertiesGroup, TranslatablePropertyByPlant, Translations } from '@/types';
import styles from '../TranslationsAccordion.module.scss';
import { getSelectedModelSeriesByGroupTranslations } from '../../../AffectedVehicles/Volume/VolumeDetails/VehicleCleanDirt/VehicleCleanDirt-utils';

interface VehiclesTabContentProps {
  tab: string;
  language: string;
  translations: Translations['affectedVehicles'];
  defaultLanguage: string;
  contentComment: (comment: string, length: number, uuid: string, plant: PlantInfo) => React.ReactNode;
  vehiclesTranslations: TranslatablePropertyByPlant[];
  validations: LanguageValidations;
  selectPlantTranslations: (plant: PlantInfo) => void;
  fieldsNumber: { [key: string]: number; total: number };
  validationActive: boolean;
  groupVehiclesTranslations: TranslatablePropertiesGroup[];
}

const VehiclesTabContent: React.FC<VehiclesTabContentProps> = (props) => {
  const { tab, language, translations, defaultLanguage, contentComment, vehiclesTranslations, validations,
    selectPlantTranslations = () => { }, fieldsNumber, validationActive, groupVehiclesTranslations } = props;
  const { t } = useTranslation();

  const affetedVehiclesPlants = tab === 'AFFECTED_VEHICLES'
    ? (translations?.translatablePropertiesByPlant || []).map(({ plant }) => plant)
    : [];
  const [plantSelected, setPlantSelected] = useState(affetedVehiclesPlants[0]);

  useEffect(() => {
    if (tab === 'AFFECTED_VEHICLES') {
      selectPlantTranslations(plantSelected);
    }
  }, [translations?.translatablePropertiesByPlant]);

  const selectPlant = (option) => {
    setPlantSelected(option);
    selectPlantTranslations(option);
  };

  return (
    <div className={styles.VehiclesTranslationsContainer}>
      <div className={styles.HeaderContainer}>
        <div className={styles.PlantsContainer}>
          {affetedVehiclesPlants.map((option) => (
            <UniversalChip
              key={option?.wkzNumber}
              chipType={chipTypes.WITH_FUNCTION}
              active={option?.wkzNumber === plantSelected?.wkzNumber}
              error={validations?.[language]?.affectedVehicles?.[option?.wkzNumber]?.invalid && validationActive}
              onClick={(() => selectPlant(option))}
              text={`${option?.plantName} (${fieldsNumber[option.wkzNumber]})`}
            />
          ))}
        </div>
      </div>
      <div className={styles.FormContent}>
        {vehiclesTranslations.map((field) => (
          (field.translations[defaultLanguage]) ? contentComment(field.code, field.length, field.uuid, plantSelected) : null))}
      </div>
      {groupVehiclesTranslations.map(({ selections, translatableProperties }) => (
        <>
          <Divider />
          <div className={styles.MSGroupTitle}>
            {t('VehicleCleanDirt.affectedCleanDirtPointCriteria')}: <span className={styles.ModelSeriesColor}>{getSelectedModelSeriesByGroupTranslations({ selections }).join(' | ')}</span>
          </div>
          <div className={styles.FormContent}>
            {translatableProperties.map((field) => (
              (field.translations[defaultLanguage]) ? contentComment(field.code, field.length, field.uuid, plantSelected) : null))}
          </div>
        </>
      ))}
    </div>
  );
};

export default VehiclesTabContent;
